import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { BehaviorSubject, catchError, filter, switchMap, take, throwError } from 'rxjs';
import { AuthService } from '../shared/services/data/auth.service';
import { SnackbarService } from '../shared/services/base/snackbar.service';
import { StorageService } from '../shared/services/base/storage.service';
import { TranslationService } from '../shared/services/base/translation.service';
import { ERROR_MESSAGES } from '../shared/data';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  const authService = inject(AuthService);
  const snackbarService = inject(SnackbarService);
  const storage = inject(StorageService);
  const translationService = inject(TranslationService);
  let isRefreshing = false;
  const refreshTokenSubject = new BehaviorSubject<string | null>(null);

  if (req.url.includes('/assets/')) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('ErrorInterceptor:', error);

      let message = ERROR_MESSAGES[error.status] ?? error.error?.message ?? translationService.instant('errors.connection');
      let snackbarType: 'error' | 'warning' | 'info' = 'error';

      if (error.status === 0) {
        message = translationService.instant('errors.noConnection');
      }


      /* if (error.status === 401) {
         if (!isBrowser) {
           return throwError(() => error);
         }

         const refreshToken = storage.get<string>('refreshToken');
         const token = storage.get<string>('token');

         if (!isRefreshing) {
           isRefreshing = true;
           refreshTokenSubject.next(null);

           if (req.url.includes('account/refresh')) {
             authService.logout();
             message = translationService.instant('errors.sessionExpiring');
             snackbarService.error(message);
             return throwError(() => error);
           }

           return authService.refreshToken({
             token: token || '',
             refreshToken: refreshToken || '',
             isWeb: true,
           }).pipe(
             switchMap((response) => {
               isRefreshing = false;

               if (!response?.token) {
                 return throwError(() => error);
               }

               storage.set('token', response.token);
               storage.set('refreshToken', response.refreshToken);
               refreshTokenSubject.next(response.token);

               const retryReq = req.clone({
                 setHeaders: {
                   Authorization: `Bearer ${response.token}`,
                   refreshToken: `${response.refreshToken}`,
                   'Accept-Language': '"es-MX"',
                 },
               });

               return next(retryReq);
             }),
             catchError((refreshError) => {
               authService.logout();
               message = translationService.instant('errors.sessionExpiring');
               snackbarService.error(message);
               isRefreshing = false;
               refreshTokenSubject.next(null);
               return throwError(() => refreshError);
             }),
           );
         }

         // ⏳ Esperar a que el refresh termine
         return refreshTokenSubject.pipe(
           filter((token) => token != null),
           take(1),
           switchMap(() => {
             const newToken = storage.get<string>('token');
             const newRefreshToken = storage.get<string>('refreshToken');

             const retryReq = req.clone({
               setHeaders: {
                 Authorization: `Bearer ${newToken}`,
                 refreshToken: `${newRefreshToken}`,
                 'Accept-Language': '"es-MX"',
               },
             });

             return next(retryReq);
           }),
         );
       }
      */
      if (error.status === 403) {
        message = error.error?.message || translationService.instant('errors.noPermission');
        snackbarType = 'warning';
      }

      if (error.status === 419) {
        authService.logout();
        message = translationService.instant('errors.sessionExpiring');
      }

      snackbarService[snackbarType](message);
      return throwError(() => error);
    }),
  );
};
